import { faArrowsRotate, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import { LeadTypeCategories } from "data/commonData";
import axiosInstance from "helpers/api";
import { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { useForm, SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

interface LeadsFilterModalProps {
  show: boolean;
  handleClose: () => void;
  setLeads: any;
}

type Inputs = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  source: string;
};

const LeadsFilterModal = ({
  show,
  handleClose,
  setLeads,
}: LeadsFilterModalProps) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const [leadType, setLeadType] = useState(null);
  const [leadStatus, setLeadStatus] = useState(null);
  const [leadTypes, setLeadTypes] = useState([]);
  const [selectedLeadStatus, setSelectedLeadStatus] = useState([]);

  const fetchLeadTypes = async () => {
    try {
      const response = await axiosInstance.get("/leads/types");
      setLeadTypes(response.data.data.leadTypes);
    } catch (error: any) {      
      toast.error(error?.response?.data?.message);
    }
  };

  const matchStatus = async (id: any) => {
    setLeadType(id);

    try {
      const response = await axiosInstance.get(`/leads/status/${id}`);
      setSelectedLeadStatus(response.data.data.leadTypes);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };
  const handleSelectStatus = (e: any) => {
    setLeadStatus(e);
  };

  useEffect(() => {
    fetchLeadTypes();
  }, []);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      console.log('🔍 [FILTER MODAL] Applying filters:', { leadType, leadStatus });
      const response = await axiosInstance.get("/dashboard/leads", {
        params: {
          lead_types_id: leadType,
          lead_type_status_id: leadStatus,
        },
      });
      console.log('🔍 [FILTER MODAL] Filter response:', response.data);
      
      // Handle response structure - match CRM dashboard logic
      const leadsData = response.data.leads || response.data.data || response.data || [];
      console.log('🔍 [FILTER MODAL] Filtered leads:', leadsData.length);
      setLeads(leadsData);
      handleClose();
    } catch (error: any) {
      console.error('❌ [FILTER MODAL] Error:', error);
      toast.error(error.response.data.message);
    }
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} className="p-0" centered>
      <Modal.Header className="border-translucent px-4">
        <h5 className="modal-title text-body-highlight fs-6 lh-sm">Filter</h5>
        <Button className="p-1 ms-auto" onClick={handleClose}>
          <FontAwesomeIcon icon={faTimes} className="fs-9" />
        </Button>
      </Modal.Header>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="pt-4 pb-2 px-4">
          <div className="mb-3">
            <Form.Group>
              <Form.Label>Lead Type</Form.Label>
              <Form.Select onChange={(e) => matchStatus(e.target.value)}>
                <option value="" disabled selected>
                  Select
                </option>
                {leadTypes.map((item: any, i: any) => (
                  <option key={i} value={item.id}>
                    {item.lead_type}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>

          <div className="mb-3">
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Select
                className="form-select"
                onChange={(e) => handleSelectStatus(e.target.value)}
              >
                <option value="" selected disabled>
                  Select
                </option>
                {selectedLeadStatus.map((item: any, i: any) => (
                  <option key={i} value={item.id}>
                    {item.status}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-end align-items-center px-4 pb-4 border-0 pt-3">
          {/* <Button
            variant="phoenix-primary"
            size="sm"
            className="px-4 fs-10 my-0"
            startIcon={
              <FontAwesomeIcon icon={faArrowsRotate} className="me-2 fs-10" />
            }
            onClick={handleClose}
          >
            Reset
          </Button> */}
          <Button
            variant="primary"
            size="sm"
            type="submit"
            className="px-9 fs-9 my-0"
          >
            Done
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default LeadsFilterModal;
